import React from 'react';
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import {useSelector} from "react-redux";
import {makeActiveNotification} from "../../../../Containers/Notifications/notificationSelectors";
import moment from "moment";

const NotificationDetails = ({localClasses, globalClasses}:any) =>{
    const activeNotification = useSelector(makeActiveNotification);

    return (
        <Card className={localClasses.card}>
            <CardHeader classes={{ root: globalClasses.cardHeader }} title="Notification Details" />
            <CardContent className={localClasses.content}>
                <Typography align="left" paragraph variant="body1">
                    <strong>Type: </strong>{' '}
                    {activeNotification && activeNotification.isSilent
                        ? 'Silent notification'
                        : 'Push notification'}
                </Typography>
                <Typography align="left" paragraph variant="body1">
                    <strong>Content:</strong> {activeNotification && activeNotification.text}
                </Typography>
                <Typography align="left" paragraph variant="body1">
                    <strong>Sent:</strong> {moment(activeNotification.timestamp).format("LLL")}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default NotificationDetails;